export default /*@ngInject*/ function () {

    const vm = this;

    vm.buttonClick = buttonClick;

    function buttonClick() {
        vm.buttonClick();
    }
}